const servicesData = [
  {
    id: 1,
    slug: "kundli-reading",
    title: "Kundli & Horoscope Reading",
    image:
      "https://i.pinimg.com/736x/fc/e1/42/fce14268f46580cff10ab9cd48e03a28.jpg",
    shortDescription:
      "Complete Birth Chart Analysis with Remedies.",
    features: [
      "Life Prediction",
      "Career",
      "Finance",
    ],
    price: "Starting ₹999",
  },

  {
    id: 2,
    slug: "mobile-number",
    title: "Mobile number consultation",
    image:
      "https://i.pinimg.com/736x/fc/e1/42/fce14268f46580cff10ab9cd48e03a28.jpg",
    shortDescription:
      "Personalized guidance based on your mobile number and numerology.",
    features: [
      "Life Prediction",
      "Career",
      "Finance",
    ],
    price: "Starting ₹999",
  },

  {
    id: 3,
    slug: "match-making",
    title: "Match Making",
    image:
      "https://i.pinimg.com/736x/f7/3e/e7/f73ee7948b4abfdc54ea7dce0c1ba8c5.jpg",
    shortDescription:
      "Gun Milan & Compatibility Analysis",
    features: [
      "Marriage Compatibility",
      "Gun Milan",
      "Relationship Guidance",
    ],
    price: "Starting ₹1499",
  },

  {
    id: 4,
    slug: "career",
    title: "Career Consultation",
    image:
      "https://i.pinimg.com/736x/35/22/cb/3522cb3e6802333feeb33c587ccd8e13.jpg",
    shortDescription:
      "Career & Business Guidance",
    features: [
      "Career Growth",
      "Business Guidance",
      "Job Prediction",
    ],
    price: "Starting ₹1999",
  },

  {
    id: 5,
    slug: "remedies",
    title: "Astrological Remedies",
    image:
      "https://i.pinimg.com/1200x/67/20/b5/6720b579eac1e6b50e26d39f36ccb624.jpg",
    shortDescription:
      "Gemstone, Rudraksha & Mantra Consultation",
    features: [
      "Gemstone Guidance",
      "Rudraksha Consultation",
      "Mantra Remedies",
    ],
    price: "Starting ₹1499",
  },

  {
    id: 6,
    slug: "muhurat",
    title: "Muhurat Selection",
    image:
      "https://i.pinimg.com/736x/b8/a4/0d/b8a40db65aba01f0ea73f8c8aba85afe.jpg",
    shortDescription:
      "Marriage, Property & Business Muhurat",
    features: [
      "Marriage Muhurat",
      "Property Muhurat",
      "Business Muhurat",
    ],
    price: "Starting ₹999",
  },

  {
    id: 7,
    slug: "premium",
    title: "Premium Consultation",
    image:
      "https://i.pinimg.com/736x/d3/f1/ef/d3f1ef82fe5a4605afd01a1956ed11d3.jpg",
    shortDescription:
      "45 Minutes Call + PDF Report",
    features: [
      "45 Minutes Consultation",
      "Detailed Analysis",
      "PDF Report",
    ],
    price: "Starting ₹2999",
  },
];

export default servicesData;